import { useState, useCallback } from 'preact/hooks';
import { type Theme, getStoredTheme, storeTheme } from '../lib/theme';

export function useTheme(defaultTheme: Theme = 'light') {
  const [theme, setThemeState] = useState<Theme>(
    () => getStoredTheme() || defaultTheme,
  );

  const toggle = useCallback(() => {
    setThemeState((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      storeTheme(next);
      return next;
    });
  }, []);

  return { theme, toggle } as const;
}
